"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames3 = _interopRequireDefault(require("classnames"));

var _grid = _interopRequireDefault(require("../grid"));

var _row = _interopRequireDefault(require("../row"));

var _col = _interopRequireDefault(require("../col"));

var _excluded = ["annotation", "ariaLabel", "ariaLabelDeterminateText", "className", "determinate", "linearBorderStyle", "max", "min", "size", "type", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CSS_PREFIX = 'vds-progress';
var CSS_STATE = 'vds-state';
var SIZES = {
  large: {
    cx: 36,
    cy: 36,
    r: 32,
    strokeDasharray: 201.062,
    strokeDashoffset: 56.2973,
    width: 72
  },
  small: {
    cx: 24,
    cy: 24,
    r: 20,
    strokeDasharray: 125.664,
    strokeDashoffset: 35.1858,
    width: 48
  }
};

var Progress = function Progress(_ref) {
  var _classnames2;

  var annotation = _ref.annotation,
      ariaLabel = _ref.ariaLabel,
      ariaLabelDeterminateText = _ref.ariaLabelDeterminateText,
      className = _ref.className,
      determinate = _ref.determinate,
      linearBorderStyle = _ref.linearBorderStyle,
      max = _ref.max,
      min = _ref.min,
      size = _ref.size,
      type = _ref.type,
      value = _ref.value,
      remainingProps = _objectWithoutProperties(_ref, _excluded);

  if (type === 'linear') {
    var _classnames;

    return /*#__PURE__*/_react.default.createElement("div", _extends({
      className: (0, _classnames3.default)(CSS_PREFIX, (_classnames = {}, _defineProperty(_classnames, "".concat(CSS_STATE, "--determinate"), Boolean(determinate)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--").concat(linearBorderStyle), Boolean(linearBorderStyle)), _classnames), className)
    }, remainingProps), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames3.default)("".concat(CSS_PREFIX, "-background"))
    }), /*#__PURE__*/_react.default.createElement("div", {
      "aria-label": "".concat(ariaLabel).concat(determinate ? ariaLabelDeterminateText(value) : ''),
      "aria-valuemax": determinate ? "".concat(max) : undefined,
      "aria-valuemin": determinate ? "".concat(min) : undefined,
      "aria-valuenow": determinate ? value : undefined,
      className: (0, _classnames3.default)("".concat(CSS_PREFIX, "-bar")),
      role: "progressbar",
      style: {
        width: determinate ? "".concat((value / max * 100).toFixed(2), "%") : undefined
      }
    }), determinate ? annotation({
      containerClassName: "".concat(CSS_PREFIX, "-label"),
      max: max,
      value: value
    }) : undefined);
  }

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames3.default)("".concat(CSS_PREFIX, "--spinner"), (_classnames2 = {}, _defineProperty(_classnames2, "".concat(CSS_STATE, "--determinate"), Boolean(determinate)), _defineProperty(_classnames2, "".concat(CSS_STATE, "--small"), size === 'small'), _classnames2), className)
  }, remainingProps), /*#__PURE__*/_react.default.createElement("svg", {
    className: "".concat(CSS_PREFIX, "--spinner-track"),
    viewBox: "0 0 ".concat(SIZES[size].width, " ").concat(SIZES[size].width),
    height: SIZES[size].width,
    width: SIZES[size].width
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "".concat(CSS_PREFIX, "--spinner-background"),
    cx: SIZES[size].cx,
    cy: SIZES[size].cy,
    r: SIZES[size].r,
    style: {
      strokeDasharray: "".concat(SIZES[size].strokeDasharray, ", ").concat(SIZES[size].strokeDasharray),
      strokeDashoffset: "".concat(SIZES[size].strokeDashoffset)
    }
  }), /*#__PURE__*/_react.default.createElement("circle", {
    className: "".concat(CSS_PREFIX, "--spinner-bar"),
    cx: SIZES[size].cx,
    cy: SIZES[size].cy,
    r: SIZES[size].r,
    style: {
      strokeDasharray: "".concat(SIZES[size].strokeDasharray, ", ").concat(SIZES[size].strokeDasharray),
      strokeDashoffset: type === 'determinate' ? SIZES[size].strokeDasharray - SIZES[size].strokeDasharray / (100 / value) : SIZES[size].strokeDashoffset
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "vds-progress-label"
  }, "".concat(value, "%")));
};

Progress.propTypes = {
  /**
   * Annotation
   */
  annotation: _propTypes.func,

  /**
   * Label
   */
  ariaLabel: _propTypes.string,

  /**
   * Aria label loaded text
   */
  ariaLabelDeterminateText: _propTypes.func,

  /**
  * @ignore
  */
  children: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.node]),

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * Determinate
   */
  determinate: _propTypes.bool,

  /**
   * Linear border style
   */
  linearBorderStyle: (0, _propTypes.oneOf)(['rounded']),

  /**
   * Value max
   */
  max: _propTypes.number,

  /**
   * Value min
   */
  min: _propTypes.number,

  /**
   * Size
   */
  size: (0, _propTypes.oneOf)(['large', 'small']),

  /**
   * Type
   */
  type: (0, _propTypes.oneOf)(['spinner', 'linear']),

  /**
   * Value
   */
  value: _propTypes.number
};
Progress.defaultProps = {
  annotation: function annotation(_ref2) {
    var containerClassName = _ref2.containerClassName,
        max = _ref2.max,
        value = _ref2.value;
    return (
      /*#__PURE__*/
      // eslint-disable-line
      _react.default.createElement(_grid.default, {
        className: (0, _classnames3.default)(containerClassName),
        type: "fluid"
      }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, null, "".concat(value, " / ").concat(max)), /*#__PURE__*/_react.default.createElement(_col.default, {
        textAlign: "right"
      }, "".concat(value, "%"))))
    );
  },
  ariaLabel: 'Progress bar',
  ariaLabelDeterminateText: function ariaLabelDeterminateText(value) {
    return ", ".concat(value, " loaded");
  },
  max: 100,
  min: 0,
  size: 'large',
  type: 'linear',
  value: 0
};
Progress.displayName = 'Progress';
var _default = Progress;
exports.default = _default;